import React from "react";
import { Zap, MapPin, Star, Clock } from "lucide-react";
import "./TrustBand.css";

const PILLARS = [
  {
    icon: <Zap size={24} />,
    title: "Fast Local Service",
    desc: "Most repairs and requests handled same day. We respect your time.",
  },
  {
    icon: <Star size={24} />,
    title: "Trusted & Reliable",
    desc: "Serving Detroit for 35+ years. Customers come back because we get it right.",
  },
  {
    icon: <MapPin size={24} />,
    title: "Neighborhood Roots",
    desc: "We're Detroit through and through. Community-first, every single day.",
  },
  {
    icon: <Clock size={24} />,
    title: "Open Mon-Sat, Closed Sunday",
    desc: "Mon–Fri 9AM–6PM. Sat 9AM-5PM. Here when you need us.",
  },
];

function TrustBand() {
  return (
    <section className="trust-band">
      <div className="container trust-band__inner">
        <div className="trust-band__label">Why City Hardware</div>
        <div className="trust-band__grid">
          {PILLARS.map((p) => (
            <div key={p.title} className="trust-pillar">
              <div className="trust-pillar__icon">{p.icon}</div>
              <h3 className="trust-pillar__title">{p.title}</h3>
              <p className="trust-pillar__desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustBand;
